import React, {Component} from "react";
import Loading from "../loading/Loading";
import Api from "../../api/Api";
import './Pisaas.css';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {history} from "../../routes/Routing";
import Authentication from "../../authentication/Authentication";
import InstancesButtons from "../instances/InstancesButtons";
import Footer from "../footer/Footer";
import PisaasInstanceInfo from "../instances/PisaasInstanceInfo"
import PisaasSignUpPopUp from "../instances/PisaasSignUpPopUp";
import PisaasCustomerSignUpPopUp from "../instances/PisaasCustomerSignUpPopUp";
import Nav from "../../nav/Nav"

export default class Pisaas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pisaasInstances: [],
            requestingPisaasInstances: false,
            showPisaasSignUp: false,
            requestingPisaasCustomerInstances: false,
            pisaasCustomerInstances: [],
            showPisaasCustomerSignUp: false,
            showTryPisaasSection: true
        };

        this.authentication = new Authentication();
    };

    componentDidMount() {
        this.load();
        this.pisaasCustomerInstanceInterval = setInterval(this.pisaasCustomerInstancesRefresh, 10000);
    }

    componentWillUnmount() {
        if (this.pisaasCustomerInstanceInterval) {
            clearInterval(this.pisaasCustomerInstanceInterval);
        }
    };

    load = () => {
        this.setState({
            loading: true
        });

        const api = new Api();

        api.pisaasFetchCustomerInstances(this.setPisaasCustomerInstances, function (err) {
            console.log(err);
            toast.error("Failed to load your instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    };

    pisaasCustomerInstancesRefresh = () => {
        const api = new Api();

        setTimeout(function (successCallback) {
            api.pisaasFetchCustomerInstances(successCallback, function (err) {
                console.log(err);
                toast.error("Failed to refresh running instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
        }, 1000, this.setPisaasCustomerInstancesMaintainRequesting);
    };

    setPisaasCustomerInstances = async (pisaasInstances) => {
        const api = new Api();

        const instancesWithData = await Promise.all(pisaasInstances.map(async (instance) => {
            const valuePromise = new Promise((resolve, reject) => {
                api.fetchServiceInfoByInstance(function (data) {
                    const instanceWithServiceInfo = {
                        ...instance,
                        "services": data[0]?.services
                    }
                    const services = data[0]?.services || [];
                    let status;
                    const isStopped = services.filter(service => (service.desiredCount === 0) && (service.runningCount === service.desiredCount)).length === services.length
                    if (isStopped) {
                        status = "stopped"
                    } else {
                        status = "pending"
                    }
                    instanceWithServiceInfo["status"] = status
                    resolve(instanceWithServiceInfo);
                }, function (err) {
                    toast.error("Failed to fetch schedeled jobs", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    reject(err);
                }, instance.domain, instance.region);
            })
            return valuePromise;
        }))

        this.setState(
            {
                pisaasCustomerInstances: instancesWithData,
                requestingPisaasCustomerInstances: false,
                loading: false
            });
    };

    setPisaasInstancesMaintainRequesting = async (pisaasInstances) => {
        const api = new Api();

        const instancesWithData = await Promise.all(pisaasInstances.map(async (instance) => {
            const valuePromise = new Promise((resolve, reject) => {
                api.fetchServiceInfoByInstance(function (data) {
                    const instanceWithServiceInfo = {
                        ...instance,
                        "services": data[0]?.services
                    }
                    const services = data[0]?.services || [];
                    let status;
                    const isStopped = services.filter(service => (service.desiredCount === 0) && (service.runningCount === service.desiredCount)).length === services.length
                    if (isStopped) {
                        status = "stopped"
                    } else {
                        status = "pending"
                    }
                    instanceWithServiceInfo["status"] = status
                    resolve(instanceWithServiceInfo);
                }, function (err) {
                    toast.error("Failed to fetch schedeled jobs", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    reject(err);
                }, instance.domain, instance.region);
            })
            return valuePromise;
        }))

        this.setState(
            {
                pisaasCustomerInstances: instancesWithData,
                requestingPisaasCustomerInstances: false,
                loading: false
            });
    };

    setPisaasCustomerInstancesMaintainRequesting = async (pisaasInstances) => {
        const api = new Api();

        const instancesWithData = await Promise.all(pisaasInstances.map(async (instance) => {
            const valuePromise = new Promise((resolve, reject) => {
                api.fetchServiceInfoByInstance(function (data) {
                    const instanceWithServiceInfo = {
                        ...instance,
                        "services": data[0]?.services
                    }
                    const services = data[0]?.services || [];
                    const dashboard = services.filter(service => service.serviceName.split("-")[0] === "dashboard")
                    let status;
                    if (dashboard[0]?.runningCount === 1) {
                        status = "running"
                    } else if (dashboard[0]?.desiredCount === 1) {
                        status = "pending"
                    } else {
                        status = "stopped"
                    }
                    instanceWithServiceInfo["status"] = status
                    resolve(instanceWithServiceInfo);
                }, function (err) {
                    toast.error("Failed to fetch schedeled jobs", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    reject(err);
                }, instance.domain, instance.region);
            })
            return valuePromise;
        }))

        this.setState(
            {
                pisaasCustomerInstances: instancesWithData,
                requestingPisaasCustomerInstances: false,
                loading: false
            });
    }

    logout = () => {
        this.authentication.logout(function () {
            history.push('/');
        });
    };

    togglePisaasCustomerCreatePopUp = () => {
        this.setState({
            showPisaasCustomerSignUp: !this.state.showPisaasCustomerSignUp
        });
    };

    renderPisaasCustomerInstanceInfo = (pisaasCustomerInstances, requesting) => {
        if (!pisaasCustomerInstances || pisaasCustomerInstances.length === 0) {
            return (
                <>
                    {requesting ?
                        <div className={"loading-container"}>
                            Requesting. This can take up to a minute.
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                            <span className="sr-only">Requesting. This can take up to a minute.</span>
                        </div>
                        :
                        <></>
                    }
                </>
            );
        } else {
            return (
                <div>
                    {requesting ?
                        <div className={"loading-container"} data-testid="pisaas.loading.container">
                            Requesting. This can take up to a minute.
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                            <span className="sr-only" data-testid="pisaas.loading.text">Requesting. This can take up to a minute.</span>
                        </div>
                        : null}
                    {pisaasCustomerInstances.map((pisaasInstance) => pisaasInstance.package_id !== 5 && pisaasInstance.package_id !== 8 && pisaasInstance.package_id !== 9  ?
                        <PisaasInstanceInfo isAdmin={this.authentication.isAdmin()} refreshPisaasInstances={this.pisaasCustomerInstancesRefresh} piSaasInstance={pisaasInstance} key={pisaasInstance.pisaas_instance_id}/>
                        : <></>)}

                </div>
            )
        }
    };

    togglePisaasCreatePopUp = () => {
        this.setState({
            showPisaasSignUp: !this.state.showPisaasSignUp
        });
    };

    render() {
        return (
            <div className={"instances-container"} data-testid="pisaas.instances.container">
                <Nav history={this.props.history}/>
                <div className={"instances-header gap-bottom-5"}>
                    <h1 className={"instances-heading"} data-testid="pisaas.instances.heading">PiSaaS</h1>
                    <InstancesButtons loading={this.state.loading} logout={this.logout} load={this.load}
                                      requestingTryPi={this.state.requestingPisaasCustomerInstances}
                                      allowCreation={false}
                                      createTryPiInstance={this.createTryPiInstance}
                                      toggleSignUp={this.togglePisaasCreatePopUp}
                    />
                </div>
                <div className="play-info" data-testid="pisaas.playInfo">
                    <h2>Play with pi instances:</h2>
                    <ul>
                        <li>PiSaaS is our Software as a Service solution where we maintain and host pi for you</li>
                        <li>Manage your PiSaaS instances here or get in contact if you would like an instance</li>
                    </ul>
                </div>
                {this.state.loading ? <Loading/> : this.state.showTryPisaasSection ? this.renderPisaasCustomerInstanceInfo(this.state.pisaasCustomerInstances, this.state.requestingPisaasCustomerInstances) : <></>}
                {this.state.showPisaasSignUp ? <PisaasSignUpPopUp togglePopUp={this.togglePisaasCreatePopUp} refreshPisaasInstances={this.pisaasInstancesRefresh}/> : <></>}
                {this.state.showPisaasCustomerSignUp ? <PisaasCustomerSignUpPopUp togglePopUp={this.togglePisaasCustomerCreatePopUp} refreshPisaasInstances={this.pisaasCustomerInstancesRefresh}/> : <></>}
                <Footer/>
            </div>
        );
    }
}
